import { IAction } from '@/redux/actions/action-helpers'
import { CustomerSuccessConsultantTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'

type CustomerSuccessConsultantState = ApplicationState['customerSuccessConsultant']

export function customerSuccessConsultantReducer(
	state: CustomerSuccessConsultantState = null,
	action: IAction,
): CustomerSuccessConsultantState {
	switch (action.type) {
		case CustomerSuccessConsultantTypes.GetCustomerSuccessConsultant.SUCCESS:
			return action.payload
	}
	return state
}
